export default "__VITE_ASSET__eJQd0lH5__"